import { messages } from './ThirdStep.messages';
import { FieldItem } from './ThirdStep.types';

export const fields: FieldItem[] = [
    {
        title: messages.accountNumber,
        name: 'bankAccount.routing.bankAccountNumber',
        requirementsKey: 'accountNumberField',
    },
    {
        title: messages.bicSwift,
        name: 'bankAccount.routing.bicSwift',
        requirementsKey: 'bicSwiftField',
    },
    {
        title: messages.iban,
        name: 'bankAccount.routing.iban',
        requirementsKey: 'ibanField',
    },
    {
        title: messages.address,
        name: 'legalEntity.addressInfo.address',
        requirementsKey: 'legalEntityAddressLineField',
    },
    {
        title: messages.city,
        name: 'legalEntity.addressInfo.city',
        requirementsKey: 'legalEntityCityField',
    },
    {
        title: messages.country,
        name: 'payerBankCountry',
        requirementsKey: 'legalEntityCountryField',
        disabled: true,
    },
    {
        title: messages.postalCode,
        name: 'legalEntity.addressInfo.postalCode',
        requirementsKey: 'legalEntityPostCodeField',
    },
    {
        title: messages.stateOrProvince,
        name: 'legalEntity.addressInfo.region',
        requirementsKey: 'legalEntityStateOrProvinceField',
    },
    {
        title: messages.companyName,
        name: 'legalEntity.companyName',
        requirementsKey: 'legalEntityCompanyNameField',
    },
    {
        title: messages.firstName,
        name: 'legalEntity.firstName',
        requirementsKey: 'legalEntityPersonFirstNameField',
    },
    {
        title: messages.lastName,
        name: 'legalEntity.lastName',
        requirementsKey: 'legalEntityPersonLastNameField',
    },
    {
        title: messages.sortCode,
        name: 'bankAccount.routing.sortCode',
        requirementsKey: 'sortCodeField',
    },
    {
        title: messages.aba,
        name: 'bankAccount.routing.aba',
        requirementsKey: 'abaField',
    },
    {
        title: messages.bsb,
        name: 'bankAccount.routing.bsb',
        requirementsKey: 'bsbField',
    },
    {
        title: messages.institutionNumber,
        name: 'bankAccount.routing.institutionNumber',
        requirementsKey: 'institutionNumberField',
    },
    {
        title: messages.incorporationNumber,
        name: 'bankAccount.routing.incorporationNumber',
        requirementsKey: 'incorporationNumberField',
    },
    {
        title: messages.bankCode,
        name: 'bankAccount.routing.bankCode',
        requirementsKey: 'bankCodeField',
    },
    {
        title: messages.branchCode,
        name: 'bankAccount.routing.branchCode',
        requirementsKey: 'branchCodeField',
    },
    {
        title: messages.clabe,
        name: 'bankAccount.routing.clabe',
        requirementsKey: 'clabeField',
    },
    {
        title: messages.cnaps,
        name: 'bankAccount.routing.cnaps',
        requirementsKey: 'cnapsField',
    },
    {
        title: messages.ifsc,
        name: 'bankAccount.routing.ifsc',
        requirementsKey: 'ifscField',
    },
];
